import { render, staticRenderFns } from "./TeachRoomLive.vue?vue&type=template&id=4d2dcd8d&"
import script from "./TeachRoomLive.vue?vue&type=script&lang=js&"
export * from "./TeachRoomLive.vue?vue&type=script&lang=js&"
import style0 from "./TeachRoomLive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports